import { useViewportSize } from '~/composables/use-viewport-size';

const isAppleDevice = () => {
  return /iPhone|iPad|iPod|Macintosh/.test(navigator?.userAgent);
};

const isSafariDesktop = () => {
  return window.safari !== undefined;
};

const isAppleIphone = () => {
  return /iPhone/.test(navigator?.userAgent);
};

const isIOSDevice = () => {
  return (
    /iPad|iPhone|iPod/.test(navigator?.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
};

// Logic to show apple pay button depending on the device
const isApplePayDeviceEnabled = () => {
  let applePayEnabled = false;
  const { isLarge, isMedium, isSmall } = useViewportSize();

  if (isAppleDevice() && (isSmall.value || isMedium.value)) {
    applePayEnabled = true;
  } else if (isAppleDevice() && isLarge.value && isSafariDesktop()) {
    applePayEnabled = true;
  }

  return applePayEnabled;
};

export { isAppleDevice, isAppleIphone, isApplePayDeviceEnabled, isIOSDevice, isSafariDesktop };
